import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import { MailOpenIcon, DocumentDownloadIcon } from "@heroicons/react/outline";
import TransferServices from "../../services/TransferServices";
import { useEffect } from "react";
import { FormatMoney } from "./../../utils/formatMoney";
import { convert, formatDate } from "./../../utils/convertDate";
import DatePicker from "react-date-picker";
import { TransferTable } from "./TransferTable";

export default function Transfers() {
  const [transfers, setTransfer] = useState([]);
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [status, setStatus] = useState("");
  const [status1, setStatus1] = useState("");
  const [active, setActive] = useState("All");
  const [total, setTotal] = useState({});
  const [type, setType] = useState("");
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7));
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));

  const listTransfer = async (
    pageIndex,
    pagesize,
    search,
    fromm,
    too,
    status,
    type
  ) => {
    const transfers = await TransferServices.listTransfers(
      pageIndex,
      pagesize,
      search,
      fromm,
      too,
      status,
      type
    );
    setTransfer(transfers.data.result);
    setPageLength(transfers?.data?.result?.length);
    setPageNumber(transfers?.data?.totalCount);
    setPageIndex(transfers?.data?.pageIndex);
    setPrev(transfers?.data?.hasPreviousPage);
    setPage(transfers?.data?.totalPages);
    setNextPage(transfers?.data?.hasNextPage);
  };

  const setTab = async (tab) => {
    tab = tab === "All" ? "" : tab;
    const list = await TransferServices.listTransfers(
      pageIndex,
      10,
      search,
      fromm,
      too,
      tab,
      type
    );
    setTransfer([...list.data.result]);
    setPageLength([...list.data.result].length);
    setPageNumber(list.data.totalCount);
    setPageIndex(list.data.pageIndex);
    setPrev(list.data.hasPreviousPage);
    setPage(list.data.totalPages);
    setStatus(tab);
    setNextPage(list.data.hasNextPage);
    setActive(tab);
  };
  const summary = async () => {
    const resp = await TransferServices.summary();
    setTotal(resp.data);
  };
  const searchTransfer = async (text) => {
    setSearch(text);
  };
  const exportTransfers = async () => {
    const resp = await TransferServices.exportTransfers(
      search,
      fromm,
      too,
      status,
      type
    );
    window.open(resp.data);
  };
  const setTranType = async (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "All") {
      setStatus1("");
    } else {
      setStatus1(selectedValue);
    }
    const response =
      (await TransferServices.listTransfers(
        pageIndex,
        10,
        search,
        fromm,
        too,
        status,
        selectedValue !== "All" ? selectedValue : ""
      )) || [];
    setTransfer([...response.data.result]);
    setPageLength([...response.data.result].length);

    setPageNumber(response.data.totalCount);
    setPageIndex(response.data.pageIndex);
    setPrev(response.data.hasPreviousPage);
    setPage(response.data.totalPages);
    setType(e.target.value);
  };
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    setFrom(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to);
    setToo(convert(toDate));

    const transfers = await TransferServices.listTransfers(
      pageIndex,
      10,
      search,
      convert(newDate),
      convert(toDate),
      status,
      type
    );
    setTransfer([...transfers?.data?.result]);
    setPageLength([...transfers.data.result].length);
    setPageNumber(transfers.data.totalCount);
    setPageIndex(transfers?.data?.pageIndex);
    setPrev(transfers.data.hasPreviousPage);
    setPage(transfers.data.totalPages);
    setNextPage(transfers.data.hasNextPage);
  };
  useEffect(() => {
    listTransfer(pageIndex, 10, search, fromm, too, status, type);
    summary();
  }, [pageIndex]);
  return (
    <>
      <Layout title={"Transfers"} pageTag={"transfers"} current={"/transfers"}>
        <React.Fragment>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="flex  justify-between">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Key Indicators
              </h3>
              <div className="hidden sm:block ml-4 mt-1">
                <nav
                  className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                  aria-label="Tabs"
                >
                  <ul
                    className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                    id="myTab"
                    aria-label="Tabs"
                  >
                    <li className="nav-item">
                      <a
                        className="group relative border  text-gray-900  min-w-max p-3 flex-1 overflow-hidden bg-white  px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                        id="home-tab"
                        data-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                        onClick={() => setTab("All")}
                      >
                        All Transfers
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="group relative border min-w-max p-3 flex-1 overflow-hidden bg-white  px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                        id="success-tab"
                        data-toggle="tab"
                        href="#success"
                        role="tab"
                        aria-controls="success"
                        aria-selected="false"
                        onClick={() => setTab("Success")}
                      >
                        Successful Transfers
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="group relative border min-w-max p-3 flex-1 overflow-hidden bg-white  px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                        id="failed-tab"
                        data-toggle="tab"
                        href="#failed"
                        role="tab"
                        aria-controls="failed"
                        aria-selected="false"
                        onClick={() => setTab("Failed")}
                      >
                        Failed Transfers
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="mt-4 sm:mt-0  sm:flex-none">
                <button
                  type="button"
                  onClick={exportTransfers}
                  className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                >
                  <DocumentDownloadIcon className="w-4 mr-1.5" />
                  Export CSV
                </button>
              </div>
            </div>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-gray-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    All Transfers
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-gray-900">
                    {FormatMoney(total.totalTransferAmount, total.currency)}
                  </p>
                </div>
                <div>
                  <p className="flex items-baseline text-sm font-semibold text-green-600">
                    {total.totalTransfer}{" "}
                  </p>
                </div>
              </div>
              <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-gray-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    Successful Transfers
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-gray-900">
                    {FormatMoney(total.successfulTransferAmount)}
                  </p>
                </div>
                <div>
                  <p className="flex items-baseline text-sm font-semibold text-green-600 pl-6">
                    {total.totalSuccessfulTransfer}{" "}
                  </p>
                </div>
              </div>
              <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-gray-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    Failed Transfers
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-gray-900">
                    {FormatMoney(total.failedTransferAmount)}
                  </p>
                </div>
                <div>
                  <p className="flex items-baseline text-sm font-semibold text-red-600">
                    {total.totalFailedTransfer}{" "}
                  </p>
                </div>
              </div>
            </dl>
            <div className="sm:flex sm:items-center mt-10">
              <div className="sm:flex-auto flex">
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className="text-sm leading-3 text-gray-500">From</p>
                  <div>
                    <DatePicker
                      onChange={dateValidation.fromHandler}
                      value={formValues.from}
                    />
                  </div>
                </div>
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className="text-sm leading-3 text-gray-500">To</p>
                  <div>
                    <DatePicker
                      onChange={dateValidation.toHandler}
                      value={formValues.to}
                    />
                  </div>
                </div>
                <div className="flex ml-4">
                  <div className="mt-5 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </div>
                    <input
                      type="text"
                      name="user"
                      id="user"
                      onChange={(e) => searchTransfer(e.target.value)}
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search transfer"
                    />
                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                      <div className="tooltip">
                        <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                        <span className="tooltiptext">
                          {" "}
                          <p>Search by account number</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                   <div className="mt-5 relative rounded-md shadow-sm ml-3">
                  <select
                    id="currency"
                    name="currency"
                    placeholder="Sort by"
                    onChange={(e) => setTranType(e)}
                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                  >
                    <option value={"All"}>Sort by</option>
                    <option value={"All"}>All</option>
                    <option value={"Intra"}>Intra</option>
                    <option value="Inter">Inter</option>
                    <option value="Virtual">Virtual</option>
                                        <option value="Virtual">Virtual</option>
                  </select>
                </div>
                <div className="mt-5 ml-4">
                  <button
                    onClick={range}
                    className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    Search
                  </button>
                </div>
             
              </div>
            </div>
            {active && (
              <>
                {transfers.length === 0 ? (
                  <div className=" mt-8">
                    {" "}
                    No data available for these dates to show.{" "}
                  </div>
                ) : (
                  <>
                    <TransferTable
                      pageIndex={pageIndex}
                      transfers={transfers}
                      pageNumber={pageNumber}
                      nextPage={nextPage}
                      setPageIndex={setPageIndex}
                      search={search}
                      prevPage={prevPage}
                      totalPage={totalPage}
                      status={status}
                      fromm={fromm}
                      pageLength={pageLength}
                      too={too}
                      type={type}
                      setTransfer={setTransfer}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </React.Fragment>
      </Layout>
    </>
  );
}
